import { DiagramMarkers } from "@/app/features/diagrams/components/shared/DiagramMarkers";
import { WorkManagementFlows } from "./WorkManagementFlows";
import { WorkManagementLegend } from "./WorkManagementLegend";
import { WorkManagementNodes } from "./WorkManagementNodes";

export type WorkManagementDrawingProps = {
  /** Keeps this drawing's arrowhead ids apart from another's on the page. */
  markerPrefix: string;
};

export function WorkManagementDrawing({
  markerPrefix,
}: WorkManagementDrawingProps) {
  return (
    <>
      <DiagramMarkers prefix={markerPrefix} />
      <WorkManagementNodes />
      <WorkManagementFlows markerPrefix={markerPrefix} />
      <WorkManagementLegend />
    </>
  );
}
